{
  "pricing": {
    "levels": {
      "RETAIL": "التجزئة",
      "WHOLESALE": "الجملة",
      "DISTRIBUTOR": "جملة الجملة"
    },
    "levelHints": {
      "RETAIL": "البيع بالمفرد",
      "WHOLESALE": "البيع بكميات",
      "DISTRIBUTOR": "البيع بكميات كبيرة للتجار والموزعين"
    },
    "prices": {
      "RETAIL": "سعر التجزئة",
      "WHOLESALE": "سعر الجملة",
      "DISTRIBUTOR": "سعر جملة الجملة",
      "CUSTOM": "السعر المخصص"
    },
    "sources": {
      "RETAIL": "تجزئة",
      "WHOLESALE": "جملة",
      "DISTRIBUTOR": "جملة الجملة",
      "CUSTOM": "مخصص"
    },
    "customHint": "سعر خاص تحدده لعميل أو فئة معينة",
    "unit": "الوحدة",
    "unitOf": "وحدة السطر {{n}}",
    "packOf": "{{factor}} × {{base}}",
    "baseUnit": "الوحدة الأساسية"
  },
  "lookup": {
    "search": "الاسم أو رمز الصنف أو الباركود…",
    "hint": "اكتب الاسم أو رمز الصنف أو الباركود، أو امسح الباركود.",
    "empty": "لا يوجد منتج مطابق.",
    "failed": "تعذّر تحميل المنتجات. حاول مرة أخرى.",
    "service": "خدمة",
    "lastCost": "آخر تكلفة",
    "averageCost": "المتوسط",
    "noCost": "لم يُشترَ من قبل"
  },
  "status": {
    "ACTIVE": "نشط",
    "INACTIVE": "غير نشط",
    "ARCHIVED": "مؤرشف"
  },
  "type": {
    "GOODS": "بضاعة",
    "SERVICE": "خدمة"
  },
  "leave": {
    "title": "تجاهل التغييرات غير المحفوظة؟",
    "body": "لديك تغييرات في هذه الصفحة لم تُحفظ بعد.",
    "confirm": "تجاهل التغييرات",
    "cancel": "متابعة التعديل"
  },
  "errors": {
    "PRODUCT_ARCHIVED": "لا يمكن تعديل منتج مؤرشف. استعِده أولًا.",
    "PRODUCT_HAS_STOCK": "لهذا المنتج حركات مخزون، لذا لم يعد بالإمكان تغيير نوعه أو وحدته أو تتبّع الأرقام التسلسلية.",
    "UNIT_IN_USE": "هناك منتجات تستخدم هذه الوحدة. انقلها إلى وحدة أخرى أولًا؛ ولا يمكن جعل وحدة تقبل الكسور وحدةً صحيحة ما دامت المنتجات تستخدمها.",
    "UNIT_SYMBOL_TAKEN": "توجد وحدة أخرى تحمل هذا الرمز الآن. غيّر رمزها أو رمز هذه الوحدة أولًا.",
    "ATTRIBUTE_IN_USE": "هناك متغيرات منتجات تستخدم هذه الخاصية. لا تُؤرشف إلا خاصية لا يستخدمها أي متغير.",
    "VALUE_IN_USE": "لا يمكن حذف قيمة تستخدمها متغيرات المنتجات. أعد تسميتها بدلًا من ذلك.",
    "CATEGORY_HAS_CHILDREN": "لهذه الفئة فئات فرعية. أرشفها أو انقلها أولًا.",
    "CATEGORY_PARENT_ARCHIVED": "استعد الفئة الأم أولًا.",
    "PRODUCT_HOLDS_STOCK": "لا يزال لهذا المنتج مخزون. سوِّه أو حوّله إلى الصفر قبل أرشفته.",
    "PRODUCT_HOLDS_STOCK_INVENTORY_OFF": "لا يزال لهذا المنتج {{quantity}} في المخزون، ولا يمكن تسوية المخزون أو تحويله ما دامت وحدة المخزون متوقفة لشركتك. اطلب من مزوّد الخدمة إعادة تشغيل وحدة المخزون، ثم أوصل المخزون إلى الصفر وأرشف المنتج.",
    "PRODUCT_HOLDS_STOCK_INVENTORY_OFF_SHORT": "مخزون هذا المنتج ليس صفرًا: {{quantity}} متوفر و{{short}} دون الصفر في مستودعاته. ولا يمكن تسوية المخزون أو تحويله ما دامت وحدة المخزون متوقفة لشركتك. اطلب من مزوّد الخدمة إعادة تشغيل وحدة المخزون، ثم أوصل المخزون إلى الصفر وأرشف المنتج.",
    "VARIANT_HOLDS_STOCK": "لا يزال لأحد المتغيرات المحذوفة مخزون. سوِّه أو حوّله إلى الصفر أولاً.",
    "CATEGORY_IN_USE": "منتجات نشطة تستخدم هذه الفئة. انقلها إلى فئة أخرى أولاً.",
    "CUSTOM_PRICE_OVERLAP": "لهذا العميل أو هذه المجموعة سعر مخصص لهذا المنتج وهذه الوحدة في هذه التواريخ. غيّر التواريخ، أو عدّل ذلك السعر بدلًا من ذلك.",
    "PACK_HAS_CUSTOM_PRICES": "لهذه العبوة أسعار مخصصة محددة بحجمها الحالي، وستنطبق كما هي على الحجم الجديد. عدّلها أو احذفها من صفحة المنتج، ثم غيّر عدد ما تحتويه العبوة.",
    "UNIT_ARCHIVED": "يُباع هذا المنتج بوحدة مؤرشفة. استعد {{units}} أولًا، ثم المنتج.",
    "UNIT_ARCHIVED_ANY": "يُباع هذا المنتج بوحدة مؤرشفة. استعد تلك الوحدة أولًا، ثم المنتج.",
    "SKU_TAKEN": "رمز صنف مستخدم في منتج آخر. غيّره واحفظ مرة أخرى.",
    "BARCODE_TAKEN": "باركود مستخدم في منتج آخر. غيّره واحفظ مرة أخرى.",
    "PRODUCT_NOT_ARCHIVED": "لا يتخلى عن رموز أصنافه وباركوده إلا منتج مؤرشف. غيّر الرمز بدلًا من ذلك."
  },
  "messages": {
    "packHoldsMore": "تحتوي العبوة على أكثر من وحدة أساسية واحدة",
    "packFactor": "أدخل عدد الوحدات الأساسية في العبوة",
    "packBoth": "أدخل العدد والوحدة معًا",
    "otherUnit": "اختر وحدة نشطة أخرى",
    "activeUnit": "اختر وحدة نشطة",
    "serialPacks": "المنتج المتتبَّع بالأرقام التسلسلية يُشترى ويُباع قطعةً قطعة، فلا عبوات له",
    "packBaseUnit": "اختر للعبوة وحدة غير الوحدة الأساسية للمنتج",
    "packTwice": "أضف كل وحدة عبوة مرة واحدة",
    "priceUnit": "سعّر وحدة يُباع بها المنتج",
    "baseRetail": "سعر التجزئة للوحدة الأساسية هو سعر المتغير",
    "priceTwice": "أدخل كل سعر مرة واحدة",
    "choosePack": "اختر إحدى العبوات",
    "onePackBarcode": "باركود واحد لكل عبوة",
    "barcodeInUse": "هذا الباركود مستخدم من قبل",
    "chooseScope": "اختر عميلًا أو مجموعة عملاء",
    "chooseGroup": "اختر مجموعة عملاء",
    "overlap": "يتداخل مع سعر مخصص آخر",
    "notSoldInUnit": "هذا المنتج لا يُباع بهذه الوحدة",
    "packHasCustomPrices": "لهذه العبوة أسعار مخصصة محددة بحجمها الحالي",
    "walkInRetail": "يشتري العميل النقدي دائمًا بسعر التجزئة"
  },
  "prices": {
    "title": "الأسعار",
    "variant": "المتغير",
    "table": "الأسعار حسب الوحدة والمستوى",
    "tableOf": "أسعار {{variant}}",
    "follows": "(غير محدد: يتبع سعر التجزئة)",
    "legendSet": "محدد على المنتج",
    "legendFallback": "يتبع سعر التجزئة"
  },
  "customPrices": {
    "title": "الأسعار المخصصة",
    "add": "إضافة سعر مخصص",
    "retry": "إعادة المحاولة",
    "failed": "تعذّر تحميل الأسعار المخصصة.",
    "empty": "لا أسعار مخصصة بعد. امنح عميلًا أو مجموعة عملاء سعرًا خاصًا لهذا المنتج: يتقدّم على أسعار التجزئة والجملة وجملة الجملة في مستنداتهم.",
    "intro": "يتقدّم هذا السعر على أسعار التجزئة والجملة وجملة الجملة في مستندات العميل.",
    "fields": {
      "for": "لمن",
      "customer": "العميل",
      "group": "مجموعة العملاء",
      "variant": "المتغير",
      "price": "السعر",
      "valid": "الصلاحية",
      "validFrom": "يسري من",
      "validTo": "يسري حتى",
      "notes": "ملاحظات"
    },
    "scope": {
      "CUSTOMER": "عميل",
      "GROUP": "مجموعة عملاء"
    },
    "actions": "الإجراءات",
    "groupStamp": "مجموعة",
    "expired": "منتهٍ",
    "upcoming": "قادم",
    "editNamed": "تعديل السعر المخصص لـ{{name}}",
    "deleteNamed": "حذف السعر المخصص لـ{{name}}",
    "delete": {
      "title": "حذف هذا السعر المخصص؟",
      "body": "يعود {{name}} إلى سعر مستواه لهذا المنتج.",
      "confirm": "حذف"
    },
    "toast": {
      "created": "أُضيف السعر المخصص",
      "updated": "حُفظ السعر المخصص",
      "deleted": "حُذف السعر المخصص"
    },
    "between": "{{from}} – {{to}}",
    "from": "من {{date}}",
    "until": "حتى {{date}}",
    "always": "دائمًا",
    "errors": {
      "notSaved": "لم يُحفظ السعر المخصص",
      "version": "عدّل شخص آخر هذا السعر المخصص. أغلق هذه اللوحة وافتحها من جديد."
    },
    "newTitle": "سعر مخصص جديد",
    "editTitle": "تعديل السعر المخصص",
    "save": "حفظ السعر المخصص",
    "hints": {
      "groupAccess": "يتطلب اختيار المجموعة صلاحية الاطلاع على العملاء.",
      "unit": "سعر الوحدة الأساسية يسري على العبوات أيضًا مضروبًا في محتواها، ما لم يكن للعبوة سعر خاص بها.",
      "price": "قبل الضريبة، لكل {{unit}}.",
      "priceRetail": "قبل الضريبة، لكل {{unit}}. سعر التجزئة {{retail}}.",
      "dates": "اترك التاريخين فارغين لسعر يبدأ الآن ولا ينتهي."
    },
    "chooseGroup": "اختر مجموعة",
    "noGroups": "لا مجموعات عملاء بعد",
    "fromNow": "من الآن",
    "noEnd": "بلا نهاية"
  },
  "products": {
    "title": "المنتجات",
    "subtitle": "البضائع التي تخزّنها والخدمات التي تبيعها، بأسعارها ورموزها والباركود.",
    "new": "منتج جديد",
    "newTitle": "منتج جديد",
    "newSubtitle": "البضائع تُخزَّن وتُجرد؛ والخدمات تُباع فقط.",
    "editTitle": "تعديل {{name}}",
    "editSubtitle": "تعديل المنتج",
    "save": "حفظ المنتج",
    "saveHint": "اضغط {{shortcut}} للحفظ",
    "views": "عروض المنتجات",
    "view": {
      "current": "الكل",
      "active": "النشطة",
      "inactive": "غير النشطة",
      "archived": "المؤرشفة"
    },
    "searchPlaceholder": "ابحث بالاسم أو رمز الصنف أو الباركود…",
    "searchLabel": "البحث في المنتجات",
    "clearSearch": "مسح البحث",
    "typeFilter": "النوع",
    "allTypes": "كل الأنواع",
    "categoryFilter": "الفئة",
    "allCategories": "كل الفئات",
    "sortLabel": "الترتيب",
    "sort": {
      "nameAsc": "الاسم تصاعديًا",
      "nameDesc": "الاسم تنازليًا",
      "newest": "الأحدث أولًا",
      "oldest": "الأقدم أولًا",
      "onHandAsc": "الكمية المتوفرة، الأقل أولاً",
      "onHandDesc": "الكمية المتوفرة، الأكثر أولاً",
      "priceAsc": "السعر، الأقل أولاً",
      "priceDesc": "السعر، الأعلى أولاً"
    },
    "tableLabel": "المنتجات",
    "clearFilters": "مسح عوامل التصفية",
    "empty": {
      "title": "لا توجد منتجات بعد.",
      "body": "أضف البضائع والخدمات التي تبيعها.",
      "filteredTitle": "لا توجد منتجات مطابقة.",
      "filteredBody": "جرّب بحثًا أو نوعًا أو فئة أخرى، أو امسح عوامل التصفية.",
      "view": {
        "active": "لا توجد منتجات نشطة.",
        "inactive": "لا توجد منتجات غير نشطة.",
        "archived": "لا توجد منتجات مؤرشفة."
      },
      "stock": {
        "low": "لا شيء عند حد إعادة الطلب أو دونه.",
        "out": "لم ينفد أي صنف."
      }
    },
    "sections": {
      "identity": "المنتج",
      "classification": "التصنيف والضريبة",
      "pricing": "السعر والمخزون",
      "overview": "نظرة عامة",
      "record": "السجل",
      "variants": "المتغيرات",
      "price": "السعر والضريبة",
      "stockUnits": "المخزون والوحدات",
      "codes": "الباركود ورمز الصنف",
      "prices": "الأسعار والضريبة"
    },
    "packs": {
      "label": "العبوات",
      "hint": "يُباع أو يُشترى أيضًا بوحدات أكبر، مثل كرتون من 12. يُحسب المخزون دائمًا بـ{{unit}}.",
      "hintNoUnit": "يُباع أو يُشترى أيضًا بوحدات أكبر، مثل كرتون من 12. يُحسب المخزون دائمًا بالوحدة الأساسية.",
      "serialHint": "المنتجات المتتبَّعة بالأرقام التسلسلية تُشترى وتُباع قطعةً قطعة، فلا عبوات لها.",
      "add": "إضافة عبوة",
      "remove": "إزالة العبوة {{n}}",
      "unitOf": "وحدة العبوة {{n}}",
      "factorOf": "محتوى العبوة {{n}} ({{unit}})",
      "holds": "تحتوي على",
      "chooseUnit": "اختر وحدة",
      "listed": "العبوات: {{packs}}"
    },
    "grid": {
      "label": "الأسعار",
      "labelOfVariant": "أسعار المتغير {{n}}",
      "cell": "{{level}} لكل {{unit}}",
      "cellOfVariant": "{{level}} لكل {{unit}}، المتغير {{n}}",
      "barcode": "باركود العبوة",
      "barcodeOf": "باركود {{unit}}",
      "barcodeOfVariant": "باركود {{unit}}، المتغير {{n}}",
      "fallback": "الخانة الفارغة تأخذ السعر الظاهر بالرمادي: تُباع العبوة بسعر الوحدة الأساسية مضروبًا في محتواها، ويُباع بالجملة وبجملة الجملة بسعر التجزئة ما لم تحدد سعرهما.",
      "fallbackDiscount": "الخانة الفارغة تأخذ السعر الظاهر بالرمادي: تُباع العبوة بسعر الوحدة الأساسية مضروبًا في محتواها، والجملة بسعر التجزئة ناقص {{wholesale}}٪، وجملة الجملة ناقص {{distributor}}٪.",
      "levelsHeader": "المستويات",
      "levelsShort": "الأسعار",
      "levelsSet": "{{n}} محدد",
      "toggleOfVariant": "الأسعار حسب المستوى، المتغير {{n}}"
    },
    "custom": {
      "noteNew": "سعر خاص لعميل أو مجموعة عملاء. حدّده من صفحة المنتج بعد حفظه.",
      "noteEdit": "سعر خاص لعميل أو مجموعة عملاء، يُحدَّد من صفحة المنتج.",
      "open": "فتح الأسعار المخصصة"
    },
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "description": "الوصف",
      "type": "النوع",
      "status": "الحالة",
      "category": "الفئة",
      "subcategory": "الفئة الفرعية",
      "unit": "الوحدة",
      "taxRate": "نسبة الضريبة",
      "trackSerials": "تتبّع الأرقام التسلسلية",
      "hasVariants": "لهذا المنتج متغيرات",
      "price": "السعر",
      "reorderLevel": "حد إعادة الطلب",
      "sku": "رمز الصنف",
      "barcode": "الباركود",
      "attributes": "الخصائص",
      "variant": "المتغير",
      "variantName": "الاسم (اختياري)",
      "variantNameAr": "الاسم بالعربية (اختياري)",
      "variantCount": "المتغيرات",
      "default": "الافتراضي",
      "createdAt": "تاريخ الإنشاء",
      "updatedAt": "آخر تعديل",
      "onHand": "الكمية المتوفرة"
    },
    "typeHint": {
      "GOODS": "تُخزَّن في المستودعات بكمياتها وتكلفتها.",
      "SERVICE": "تُباع فقط ولا يُحتفظ لها بمخزون."
    },
    "hints": {
      "structural": "بعد أول حركة مخزون لا يمكن تغيير النوع أو الوحدة أو تتبّع الأرقام التسلسلية.",
      "status": "المنتجات غير النشطة تبقى في السجل لكنها لا تُعرض في المستندات الجديدة.",
      "taxRate": "تُقترح في بنود المستندات لهذا المنتج.",
      "trackSerials": "لكل وحدة رقمها التسلسلي الخاص.",
      "pricingGoods": "سعر البيع قبل الضريبة، والرموز المطبوعة أو الممسوحة، ومتى يُعاد الطلب.",
      "pricingService": "سعر البيع قبل الضريبة، والرموز المستخدمة للعثور على الخدمة.",
      "hasVariants": "المقاسات والألوان ونحوها: لكل متغير رمزه وباركوده وسعره ومخزونه.",
      "price": "قبل الضريبة.",
      "reorderLevel": "يُنبَّه إلى المخزون عند هذا الحد أو دونه.",
      "reorderLevelIn": "بوحدة {{unit}}. يُنبَّه إلى المخزون عند هذا الحد أو دونه.",
      "barcode": "امسحه في الحقل أو اكتبه.",
      "attributes": "حتى {{max}}، مثل اللون والمقاس.",
      "variants": "اترك الاسم فارغًا ليُستخدم اسم القيم (\"أحمر / كبير\"). الأسعار قبل الضريبة."
    },
    "noCategory": "بلا فئة",
    "searchCategories": "ابحث في الفئات…",
    "noCategories": "لا توجد فئة مطابقة.",
    "clearCategory": "بلا فئة",
    "noSubcategory": "بلا فئة فرعية",
    "searchSubcategories": "ابحث في الفئات الفرعية…",
    "noSubcategories": "لا توجد فئة فرعية مطابقة.",
    "chooseUnit": "اختر وحدة",
    "noTax": "بلا ضريبة",
    "chooseAttributes": "اختر الخصائص",
    "searchAttributes": "ابحث في الخصائص…",
    "noAttributes": "لا توجد خصائص بعد. أضفها من صفحة الخصائص.",
    "clearAttributes": "مسح",
    "chooseValue": "اختر",
    "variantsTable": "المتغيرات",
    "addVariant": "إضافة متغير",
    "removeVariant": "حذف المتغير {{n}}",
    "variantActions": "إجراءات المتغير",
    "valueOfVariant": "{{attribute}} للمتغير {{n}}",
    "nameOfVariant": "اسم المتغير {{n}}",
    "nameArOfVariant": "الاسم العربي للمتغير {{n}}",
    "skuOfVariant": "رمز صنف المتغير {{n}}",
    "barcodeOfVariant": "باركود المتغير {{n}}",
    "priceOfVariant": "سعر المتغير {{n}}",
    "reorderOfVariant": "حد إعادة الطلب للمتغير {{n}}",
    "defaultVariant": "المتغير {{n}} هو الافتراضي",
    "defaultStamp": "افتراضي",
    "generate": {
      "action": "توليد المتغيرات…",
      "title": "توليد المتغيرات",
      "body": "اختر قيمًا لكل خاصية. تُضاف كل تركيبة غير موجودة في المنتج، بسعر المتغير الأول.",
      "confirm_zero": "لا متغيرات للإضافة",
      "confirm_one": "إضافة متغير واحد",
      "confirm_two": "إضافة متغيرين",
      "confirm_few": "إضافة {{count}} متغيرات",
      "confirm_many": "إضافة {{count}} متغيرًا",
      "confirm_other": "إضافة {{count}} متغير",
      "chooseValues": "اختر القيم",
      "searchValues": "ابحث في القيم…",
      "noValues": "لا توجد قيمة مطابقة.",
      "clear": "مسح",
      "selected": "{{n}} مختارة"
    },
    "errors": {
      "notSaved": "لم يُحفظ المنتج",
      "chooseUnit": "اختر وحدة",
      "chooseAttribute": "اختر خاصية واحدة على الأقل",
      "tooManyAttributes": "اختر {{max}} خصائص كحد أقصى",
      "chooseValue": "اختر قيمة لكل خاصية",
      "duplicateCombination": "لمتغير آخر القيم نفسها",
      "duplicateSku": "رمز الصنف هذا مستخدم في متغير آخر",
      "duplicateBarcode": "الباركود هذا مستخدم في متغير آخر",
      "activeUnit": "اختر وحدة نشطة",
      "activeCategory": "اختر فئة نشطة",
      "serviceSerials": "الخدمات لا تُخزَّن ولا يمكن تتبّع أرقامها التسلسلية",
      "skuTaken": "رمز صنف مستخدم في منتج آخر. غيّره واحفظ مرة أخرى.",
      "barcodeTaken": "باركود مستخدم في منتج آخر. غيّره واحفظ مرة أخرى.",
      "serialPacks": "أزل العبوات: المنتج المتتبَّع بالأرقام التسلسلية يُشترى ويُباع قطعةً قطعة",
      "packBaseUnit": "اختر وحدة غير الوحدة الأساسية للمنتج",
      "packTwice": "هذه الوحدة مضافة عبوةً من قبل",
      "packFactor": "أدخل عدد الوحدات الأساسية في العبوة"
    },
    "codeHolder": {
      "titleSku": "رمز الصنف هذا مستخدم",
      "titleBarcode": "هذا الباركود مستخدم",
      "archivedSku": "رمز الصنف {{code}} يعود إلى المنتج المؤرشف {{name}}.",
      "archivedBarcode": "الباركود {{code}} يعود إلى المنتج المؤرشف {{name}}.",
      "activeSku": "رمز الصنف {{code}} يعود إلى المنتج {{name}}. غيّره هنا أو في ذلك المنتج، ثم احفظ مرة أخرى.",
      "activeBarcode": "الباركود {{code}} يعود إلى المنتج {{name}}. غيّره هنا أو في ذلك المنتج، ثم احفظ مرة أخرى.",
      "releaseNote": "استعد ذلك المنتج لاستخدامه من جديد، أو حرّر رموزه لهذا المنتج: يُضاف إلى رموز أصنافه «-ARC-» ومعرّف قصير، ويُمسح الباركود، ويبقى مؤرشفًا.",
      "askArchiver": "اطلب ممن يملك صلاحية أرشفة المنتجات أن يستعيده أو يحرّر رموزه، أو غيّر الرمز هنا.",
      "restore": "استعادته",
      "release": "حرّر الرمز واحفظ",
      "open": "فتح {{name}}",
      "back": "العودة إلى النموذج"
    },
    "conflict": {
      "title": "عدّل شخص آخر هذا المنتج",
      "body": "أعد التحميل للحصول على تغييراته. ستُستبدل تعديلاتك في هذه الصفحة.",
      "reload": "إعادة التحميل"
    },
    "archivedTitle": "هذا المنتج مؤرشف",
    "backToProduct": "العودة إلى المنتج",
    "archive": "أرشفة",
    "restore": "استعادة",
    "archiveDialog": {
      "title": "أرشفة {{name}}؟",
      "body": "سيختفي من القوائم وأدوات الاختيار. تبقى مستنداته وسجل مخزونه، ويمكنك استعادته لاحقًا."
    },
    "restoreDialog": {
      "title": "استعادة {{name}}؟",
      "body": "سيصبح متاحًا في المستندات الجديدة مرة أخرى."
    },
    "movements": "حركات المخزون",
    "movementsOf": "حركات مخزون {{name}}",
    "yes": "نعم",
    "no": "لا",
    "toast": {
      "created": "أُضيف {{name}}",
      "updated": "حُفظ {{name}}",
      "archived": "أُرشف {{name}}",
      "restored": "استُعيد {{name}}",
      "exported_zero": "تم تصدير {{n}} منتج",
      "exported_one": "تم تصدير منتج واحد",
      "exported_two": "تم تصدير منتجين",
      "exported_few": "تم تصدير {{n}} منتجات",
      "exported_many": "تم تصدير {{n}} منتجاً",
      "exported_other": "تم تصدير {{n}} منتج",
      "exportedView": "تم تصدير العرض"
    },
    "lowStockMarker": "عند حد إعادة الطلب أو دونه",
    "notStocked": "غير مخزّن",
    "movementsShort": "الحركات",
    "export": "تصدير العرض",
    "exportHint_zero": "ملف CSV بالمنتجات في هذا العرض ({{n}})",
    "exportHint_one": "ملف CSV بمنتج واحد في هذا العرض",
    "exportHint_two": "ملف CSV بمنتجين في هذا العرض",
    "exportHint_few": "ملف CSV بـ {{n}} منتجات في هذا العرض",
    "exportHint_many": "ملف CSV بـ {{n}} منتجاً في هذا العرض",
    "exportHint_other": "ملف CSV بـ {{n}} منتج في هذا العرض",
    "warehouseFilter": "المستودع",
    "allWarehouses": "كل المستودعات",
    "onHandIn": "الكمية المتوفرة في {{warehouse}}",
    "stockView": {
      "low": "مخزون منخفض",
      "out": "نفد المخزون"
    },
    "archiveBlocked": {
      "stock": "لا يزال {{quantity}} متوفراً: سوِّه أو حوّله إلى الصفر أولاً",
      "checking": "جارٍ التحقق من المخزون…",
      "unavailable": "تعذّر تحميل المخزون"
    },
    "priceTo": "حتى {{price}}",
    "stats": {
      "label": "أرقام المنتجات",
      "active": "المنتجات النشطة",
      "ofAll": "من {{total}}",
      "activeShare": "{{percent}}٪ من المنتجات نشطة",
      "stockValue": "قيمة المخزون",
      "stockValueDetail_zero": "لا أصناف بالتكلفة",
      "stockValueDetail_one": "صنف واحد بالتكلفة",
      "stockValueDetail_two": "صنفان بالتكلفة",
      "stockValueDetail_few": "{{n}} أصناف بالتكلفة",
      "stockValueDetail_many": "{{n}} صنفًا بالتكلفة",
      "stockValueDetail_other": "{{n}} صنف بالتكلفة",
      "outDetail": "لا كمية متوفرة",
      "unavailable": "الأرقام غير متاحة",
      "products_zero": "لا منتجات",
      "products_one": "منتج واحد",
      "products_two": "منتجان",
      "products_few": "{{n}} منتجات",
      "products_many": "{{n}} منتجًا",
      "products_other": "{{n}} منتج"
    },
    "sectionHints": {
      "identity": "اسم المنتج وتصنيفه.",
      "priceVariants": "لكل متغير سعره، ويُحدَّد في المتغيرات أدناه.",
      "stockGoods": "الوحدة التي يُعدّ بها، ومتى يُعاد طلبه.",
      "stockService": "الوحدة التي يُباع بها.",
      "codes": "للمسح عند نقطة البيع وعلى المستندات.",
      "price": "سعر البيع قبل الضريبة، والضريبة المضافة على بنود المستندات.",
      "prices": "سعر كل وحدة في كل مستوى قبل الضريبة. سعر التجزئة للوحدة الأساسية وحده إلزامي."
    }
  },
  "units": {
    "title": "الوحدات",
    "subtitle": "الوحدات التي تُعدّ بها المنتجات وتُباع وتُخزَّن.",
    "new": "وحدة جديدة",
    "newTitle": "وحدة جديدة",
    "newSubtitle": "مثل حبة أو علبة أو كيلوغرام أو لتر.",
    "editTitle": "تعديل الوحدة",
    "save": "حفظ الوحدة",
    "actions": "إجراءات",
    "showArchived": "إظهار المؤرشفة",
    "empty": "لا توجد وحدات بعد.",
    "editNamed": "تعديل {{name}}",
    "archiveNamed": "أرشفة {{name}}",
    "restoreNamed": "استعادة {{name}}",
    "fractions": "تقبل الكسور",
    "wholeOnly": "وحدات صحيحة فقط",
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "symbol": "الرمز",
      "symbolAr": "الرمز بالعربية",
      "allowFractions": "السماح بالكميات العشرية",
      "status": "الحالة",
      "packOf": "محتوى العبوة المعتاد",
      "usage": "الاستخدام"
    },
    "hints": {
      "symbol": "يظهر بعد الكميات، مثل pc أو kg.",
      "allowFractions": "للأوزان والأحجام (1.5 كغ). اتركه مغلقًا لما يُعدّ بالقطعة.",
      "allowFractionsInUse": "تستخدم منتجات هذه الوحدة، لذا تبقى تقبل الكسور.",
      "packOf": "لوحدة عبوة مثل الكرتون: ما تحتويه عادةً. المنتج الذي يضيفها عبوةً يبدأ بهذا العدد ويمكنه تغييره."
    },
    "packOfValue": "1 {{unit}} = {{factor}} {{base}}",
    "holds": "تحتوي على",
    "packFactor": "العدد الذي تحتويه",
    "packOfUnit": "الوحدة التي تحتويها",
    "chooseUnit": "اختر وحدة",
    "clearPackOf": "ليست عبوة",
    "usage": {
      "none": "غير مستخدمة بعد",
      "baseOf_zero": "لا منتجات",
      "baseOf_one": "منتج واحد",
      "baseOf_two": "منتجان",
      "baseOf_few": "{{n}} منتجات",
      "baseOf_many": "{{n}} منتجًا",
      "baseOf_other": "{{n}} منتج",
      "packOf_zero": "ليست عبوة في أي منتج",
      "packOf_one": "عبوة في منتج واحد",
      "packOf_two": "عبوة في منتجين",
      "packOf_few": "عبوة في {{n}} منتجات",
      "packOf_many": "عبوة في {{n}} منتجًا",
      "packOf_other": "عبوة في {{n}} منتج"
    },
    "archive": {
      "title": "أرشفة {{name}}؟",
      "body": "لن يمكن اختيارها للمنتجات بعد الآن. لا تُؤرشف إلا وحدة لا يستخدمها أي منتج نشط.",
      "confirm": "أرشفة"
    },
    "restore": {
      "title": "استعادة {{name}}؟",
      "body": "يمكن اختيارها للمنتجات مرة أخرى.",
      "confirm": "استعادة"
    },
    "errors": {
      "nameTaken": "توجد وحدة أخرى بهذا الاسم.",
      "symbolTaken": "توجد وحدة أخرى بهذا الرمز.",
      "version": "عدّل شخص آخر هذه الوحدة. أغلق هذه اللوحة وافتحها مرة أخرى."
    },
    "toast": {
      "created": "أُضيفت الوحدة",
      "updated": "حُفظت الوحدة",
      "archived": "أُرشفت الوحدة",
      "restored": "استُعيدت الوحدة"
    }
  },
  "categories": {
    "title": "فئات المنتجات",
    "subtitle": "جمّع المنتجات لتسهيل البحث والتقارير. يمكن أن تكون للفئات فئات فرعية.",
    "new": "فئة جديدة",
    "newTitle": "فئة جديدة",
    "newSub": "فئة فرعية جديدة",
    "newSubtitle": "فئة رئيسية، ما لم تختر فئة أم.",
    "newUnder": "تحت {{name}}",
    "editTitle": "تعديل الفئة",
    "save": "حفظ الفئة",
    "actions": "إجراءات",
    "searchPlaceholder": "ابحث في الفئات…",
    "searchLabel": "البحث في الفئات",
    "clearSearch": "مسح البحث",
    "showArchived": "إظهار المؤرشفة",
    "expandAll": "توسيع الكل",
    "collapseAll": "طي الكل",
    "empty": "لا توجد فئات بعد.",
    "emptyFiltered": "لا توجد فئات مطابقة.",
    "addUnder": "إضافة فئة تحت {{name}}",
    "editNamed": "تعديل {{name}}",
    "archiveNamed": "أرشفة {{name}}",
    "restoreNamed": "استعادة {{name}}",
    "productsIn": "المنتجات في {{name}}",
    "topLevel": "فئة رئيسية",
    "makeTopLevel": "اجعلها فئة رئيسية",
    "searchParent": "ابحث في الفئات…",
    "noParents": "لا توجد فئة مطابقة.",
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "productCount": "المنتجات",
      "parent": "الفئة الأم"
    },
    "hints": {
      "parent": "اتركها فارغة لفئة رئيسية."
    },
    "archive": {
      "title": "أرشفة {{name}}؟",
      "body": "لن يمكن اختيارها للمنتجات بعد الآن. لا تُؤرشف فئة تستخدمها منتجات نشطة أو لها فئات فرعية: انقلها أولًا.",
      "confirm": "أرشفة"
    },
    "restore": {
      "title": "استعادة {{name}}؟",
      "body": "يمكن اختيارها للمنتجات مرة أخرى. تنتظر الفئة الفرعية استعادة فئتها الأم.",
      "confirm": "استعادة"
    },
    "errors": {
      "nameTaken": "توجد فئة أخرى بهذا الاسم.",
      "version": "عدّل شخص آخر هذه الفئة. أغلق هذه اللوحة وافتحها مرة أخرى.",
      "loop": "لا يمكن وضع الفئة تحت نفسها أو تحت إحدى فئاتها الفرعية.",
      "activeParent": "اختر فئة أم نشطة."
    },
    "toast": {
      "created": "أُضيفت الفئة",
      "updated": "حُفظت الفئة",
      "archived": "أُرشفت الفئة",
      "restored": "استُعيدت الفئة"
    }
  },
  "attributes": {
    "title": "الخصائص",
    "subtitle": "ما تختلف به المتغيرات، مثل اللون أو المقاس، والقيم التي تأخذها.",
    "new": "خاصية جديدة",
    "newTitle": "خاصية جديدة",
    "newSubtitle": "مثل اللون، بقيم أحمر وأزرق وأسود.",
    "editTitle": "تعديل الخاصية",
    "save": "حفظ الخاصية",
    "actions": "إجراءات",
    "showArchived": "إظهار المؤرشفة",
    "empty": "لا توجد خصائص بعد.",
    "emptyBody": "أضف خصائص لبيع المنتجات بمتغيرات، مثل المقاسات أو الألوان.",
    "editNamed": "تعديل {{name}}",
    "archiveNamed": "أرشفة {{name}}",
    "restoreNamed": "استعادة {{name}}",
    "more": "و{{n}} أخرى",
    "fields": {
      "status": "الحالة",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "values": "القيم",
      "value": "القيمة",
      "valueAr": "القيمة بالعربية"
    },
    "hints": {
      "values": "بالترتيب الذي تُعرض به.",
      "inUse": "إعادة تسمية قيمة تحدّث كل متغير يستخدمها. ولا يمكن حذف قيمة مستخدمة."
    },
    "valueN": "القيمة {{n}}",
    "valueArN": "القيمة {{n}} بالعربية",
    "moveUp": "نقل القيمة {{n}} للأعلى",
    "moveDown": "نقل القيمة {{n}} للأسفل",
    "removeValue": "حذف القيمة {{n}}",
    "addValue": "إضافة قيمة",
    "archive": {
      "title": "أرشفة {{name}}؟",
      "body": "لن تُعرض بعد الآن للمتغيرات الجديدة. لا تُؤرشف إلا خاصية لا يستخدمها أي متغير منتج.",
      "confirm": "أرشفة"
    },
    "restore": {
      "title": "استعادة {{name}}؟",
      "body": "تُعرض للمتغيرات مرة أخرى.",
      "confirm": "استعادة"
    },
    "errors": {
      "nameTaken": "توجد خاصية أخرى بهذا الاسم.",
      "duplicateValue": "لا يمكن تكرار القيمة."
    },
    "toast": {
      "created": "أُضيفت الخاصية",
      "updated": "حُفظت الخاصية",
      "archived": "أُرشفت الخاصية",
      "restored": "استُعيدت الخاصية"
    }
  },
  "actions": {
    "open": "فتح",
    "adjust": "تسوية المخزون",
    "count": "جرد المخزون",
    "transfer": "تحويل",
    "labels": "طباعة الملصقات",
    "retryFigures": "تحميل المخزون مجدداً",
    "rowActions": "إجراءات {{name}}"
  },
  "profile": {
    "figures": "أرقام المنتج",
    "figuresFailed": "تعذّر تحميل أرقام المنتج.",
    "onHand": "الكمية المتوفرة",
    "value": "القيمة بالتكلفة",
    "averageCost": "متوسط التكلفة",
    "noCostYet": "لا تكلفة بعد",
    "reorder": {
      "NEGATIVE": "دون الصفر في أحد المستودعات",
      "OUT": "نفد المخزون",
      "LOW": "عند حد إعادة الطلب أو دونه",
      "OK": "فوق حد إعادة الطلب",
      "OKAt": "إعادة الطلب عند {{level}}"
    },
    "price": "السعر",
    "priceExTax": "غير شامل {{tax}}",
    "priceNoTax": "بلا ضريبة",
    "netSalesHead": "صافي المبيعات",
    "soldQuantity": "بيع {{quantity}}",
    "lastSale": "آخر بيع",
    "lastPurchase": "آخر شراء",
    "never": "لا شيء بعد",
    "serialsStamp": "أرقام تسلسلية",
    "archivedBanner": "مؤرشف في {{date}}. لا يظهر في القوائم المنسدلة، وتبقى مستنداته وسجل مخزونه.",
    "inactiveBanner": "غير نشط: لا يُعرض في المستندات الجديدة.",
    "tabs": {
      "label": "أقسام المنتج",
      "overview": "نظرة عامة",
      "stock": "المخزون",
      "sales": "المبيعات",
      "purchases": "المشتريات",
      "attachments": "المرفقات",
      "serials": "الأرقام التسلسلية"
    },
    "attention": {
      "title": "يحتاج إلى متابعة",
      "none": "لا شيء يحتاج إلى متابعة.",
      "unavailable": "غير متاح",
      "negative_zero": "مستودعات دون الصفر",
      "negative_one": "مستودع دون الصفر",
      "negative_two": "مستودعان دون الصفر",
      "negative_few": "مستودعات دون الصفر",
      "negative_many": "مستودعاً دون الصفر",
      "negative_other": "مستودع دون الصفر",
      "low_zero": "متغيرات عند حد إعادة الطلب أو دونه",
      "low_one": "متغير عند حد إعادة الطلب أو دونه",
      "low_two": "متغيران عند حد إعادة الطلب أو دونه",
      "low_few": "متغيرات عند حد إعادة الطلب أو دونه",
      "low_many": "متغيراً عند حد إعادة الطلب أو دونه",
      "low_other": "متغير عند حد إعادة الطلب أو دونه",
      "noCost_zero": "متغيرات مخزّنة بلا تكلفة",
      "noCost_one": "متغير مخزّن بلا تكلفة",
      "noCost_two": "متغيران مخزّنان بلا تكلفة",
      "noCost_few": "متغيرات مخزّنة بلا تكلفة",
      "noCost_many": "متغيراً مخزّناً بلا تكلفة",
      "noCost_other": "متغير مخزّن بلا تكلفة",
      "noBarcode_zero": "متغيرات بلا باركود",
      "noBarcode_one": "متغير بلا باركود",
      "noBarcode_two": "متغيران بلا باركود",
      "noBarcode_few": "متغيرات بلا باركود",
      "noBarcode_many": "متغيراً بلا باركود",
      "noBarcode_other": "متغير بلا باركود"
    },
    "variantCount_zero": "لا متغيرات",
    "variantCount_one": "متغير واحد",
    "variantCount_two": "متغيران",
    "variantCount_few": "{{n}} متغيرات",
    "variantCount_many": "{{n}} متغيراً",
    "variantCount_other": "{{n}} متغير",
    "heldIn_zero": "غير مخزّن في أي مستودع",
    "heldIn_one": "في مستودع واحد",
    "heldIn_two": "في مستودعين",
    "heldIn_few": "في {{n}} مستودعات",
    "heldIn_many": "في {{n}} مستودعاً",
    "heldIn_other": "في {{n}} مستودع",
    "weightedAverage": "مرجّح على كل المستودعات",
    "margin": "هامش الربح",
    "marginPerUnit": "للوحدة",
    "marginOnPrice": "على السعر دون الضريبة",
    "noMarginYet": "لا تكلفة للمقارنة بعد"
  },
  "stockTab": {
    "unavailable": "تعذّر تحميل المخزون.",
    "onHandTitle": "الكمية المتوفرة حسب المستودع",
    "cellHint": "اختر كمية لعرض حركاتها مع الرصيد الجاري.",
    "neverStocked": "لم يُخزَّن في أي مستودع.",
    "product": "المنتج",
    "total": "الإجمالي",
    "averageCost": "متوسط التكلفة",
    "value": "القيمة",
    "cellLabel": "{{variant}} في {{warehouse}}: {{quantity}}",
    "movementsTitle": "حركات المخزون",
    "variantFilter": "المتغير",
    "allVariants": "كل المتغيرات",
    "clearSelection": "عرض كل الحركات",
    "allMovements": "فتح في حركات المخزون",
    "runningHint": "اختر مستودعاً ومتغيراً واحداً لعرض الرصيد الجاري.",
    "noMovements": "لا توجد حركات مخزون.",
    "warehousesTitle": "المستودعات",
    "reorderAt": "حد إعادة الطلب {{level}}",
    "warehouseRow": "{{warehouse}}: {{quantity}}",
    "state": {
      "low": "منخفض",
      "out": "نفد",
      "negative": "دون الصفر"
    },
    "allWarehouses": "كل المستودعات",
    "onHand": "المتوفر"
  },
  "history": {
    "salesTitle": "المبيعات",
    "purchasesTitle": "المشتريات",
    "partyHidden": "المورد مخفي",
    "hint": "المستندات المرحّلة، الأحدث أولاً. المبالغ غير شاملة الضريبة، والمرتجعات بالسالب.",
    "clearFilters": "مسح عوامل التصفية",
    "emptyFiltered": "لا توجد بنود مطابقة.",
    "emptySales": "لم يُبع بعد.",
    "emptyPurchases": "لم يُشترَ بعد.",
    "docType": {
      "INVOICE": "فاتورة",
      "DEBIT_NOTE": "إشعار مدين",
      "CREDIT_NOTE": "إشعار دائن",
      "PURCHASE": "فاتورة شراء",
      "SUPPLIER_RETURN": "مرتجع مورد"
    },
    "fields": {
      "date": "التاريخ",
      "document": "المستند",
      "customer": "العميل",
      "supplier": "المورد",
      "quantity": "الكمية",
      "unitPrice": "سعر الوحدة",
      "unitCost": "تكلفة الوحدة",
      "net": "الصافي"
    },
    "scopeRestricted": {
      "title": "سجل المشتريات غير متاح لك",
      "body": "يشمل السجل جميع مشتريات هذا المنتج، وصلاحيتك محصورة في جزء من المشتريات."
    },
    "salesScopeRestricted": {
      "title": "سجل المبيعات غير متاح لك",
      "body": "يشمل السجل جميع مبيعات هذا المنتج، وصلاحيتك محصورة في جزء من مستندات المبيعات."
    }
  },
  "labels": {
    "title": "ملصقات {{name}}",
    "subtitle": "ملصقات باركود للرف أو للبضاعة.",
    "back": "العودة إلى المنتج",
    "print_zero": "طباعة الملصقات",
    "print_one": "طباعة ملصق واحد",
    "print_two": "طباعة ملصقين",
    "print_few": "طباعة {{count}} ملصقات",
    "print_many": "طباعة {{count}} ملصقاً",
    "print_other": "طباعة {{count}} ملصق",
    "variantsTable": "الملصقات المطلوب طباعتها",
    "product": "المنتج",
    "code": "الرمز",
    "copies": "النسخ",
    "copiesOf": "نسخ {{name}}",
    "format": {
      "EAN13": "EAN-13",
      "CODE128": "Code 128"
    },
    "cannotEncode": "لا يمكن طباعته باركوداً",
    "noCode": "لا باركود ولا رمز منتج",
    "unprintable_zero": "لا توجد متغيرات بلا رمز.",
    "unprintable_one": "متغير واحد ليس له رمز يُطبع باركوداً. أضف له باركوداً أو رمز منتج.",
    "unprintable_two": "متغيران ليس لهما رمز يُطبع باركوداً. أضف لهما باركوداً أو رمز منتج.",
    "unprintable_few": "{{count}} متغيرات ليس لها رمز يُطبع باركوداً. أضف لها باركوداً أو رمز منتج.",
    "unprintable_many": "{{count}} متغيراً ليس لها رمز يُطبع باركوداً. أضف لها باركوداً أو رمز منتج.",
    "unprintable_other": "{{count}} متغير ليس لها رمز يُطبع باركوداً. أضف لها باركوداً أو رمز منتج.",
    "size": "مقاس الملصق",
    "sizes": {
      "roll50x25": "لفة 50 × 25 ملم",
      "roll38x25": "لفة 38 × 25 ملم",
      "a4x24": "ورقة A4، ‏24 ملصقاً (70 × 37 ملم)"
    },
    "showName": "طباعة الاسم",
    "showPrice": "طباعة السعر",
    "priceIncludes": "الأسعار شاملة {{tax}}.",
    "priceNoTax": "الأسعار بلا ضريبة.",
    "none": "اختر نسخة واحدة على الأقل للطباعة.",
    "preview": "معاينة الملصقات",
    "listTitle": "الملصقات المطلوب طباعتها",
    "optionsTitle": "خيارات الملصق",
    "previewTitle": "معاينة"
  }
}
